import { Component, input, output } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DisabilityProof } from '../../../../api/app-types/disability-proof.app';
import { Paginator } from '../../../../core/components/paginator/paginator';
import { DisabilityProofItem } from '../disability-proof-item/disability-proof-item';

@Component({
	selector: 'lvr-disability-proof-list',
	templateUrl: './disability-proof-list.html',
	styleUrl: './disability-proof-list.scss',
	imports: [TranslocoPipe, DisabilityProofItem, MatPaginatorModule, Paginator, RouterLink],
})
export class DisabilityProofList {
	public readonly disabilityProofs = input.required<DisabilityProof[]>();
	public readonly totalItems = input.required<number>();
	public readonly pageIndex = input.required<number>();
	public readonly pageSize = input.required<number>();
	public readonly showFirstLastButtons = input<boolean>(true);
	public readonly hidePageSize = input<boolean>(false);
	public readonly pageChange = output<PageEvent>();

	/**
	 * Handles the page event
	 * @param e The page event
	 */
	public handlePageEvent(event: PageEvent) {
		this.pageChange.emit(event);
	}
}
